const state = {
  steps: {
    nbQuestions: 0,
    nowStep: 1,
    nowStep_temporary: null,
    nowStepSection: 0,
    stepsLength: [],
    stepsLengthSection: [],
    authorizedVote: true,
    authorizedThanks: false,
    authorizedSendForm: false,
    resetStepsLength: 1,
    currentSection: 0,
    relation_section: 0
  },
  buttons: {
    localShowButton: []
  },
  indexConditionalSection: 0,
  radioAnswerConditonalSection: null,
  radioOptionalQuestion: [],
  choosenLanguageClient: null,
  errorMaxCheckboxes: false,
  sondage: {
    id: null,
    urlModerateur: null
  }
}

const mutations = {
  CLIENT_SONDAGE_ID (state, payload) {
    state.sondage.id = payload
  },
  CLIENT_SONDAGE_URL_MODERATEUR (state, payload) {
    state.sondage.urlModerateur = payload
  },
  ERROR_MAX_CHECKBOXES (state, payload) {
    state.errorMaxCheckboxes = payload
  },
  UPDATE_CHOOSEN_LANGUAGE_CLIENT (state, payload) {
    state.choosenLanguageClient = payload
  },
  NB_QUESTIONS (state, payload) {
    state.steps.nbQuestions = 0
    payload.forEach(section => {
      state.steps.nbQuestions += section.questions.length
    })
  },
  STEPS_LENGTH (state, payload) {
    switch (payload.type) {
      case 'questions':
        state.steps.stepsLength = []
        payload.data.forEach(function () {
          state.steps.stepsLength.push(null)
        })
        break
      case 'sections':
        // on passe à la section suivante
        if (payload.params === 'section_suivante') {
          if (state.radioAnswerConditonalSection !== null) {
            if (state.radioAnswerConditonalSection === 0) {
              state.steps.stepsLengthSection.splice(0, state.steps.stepsLengthSection.length - state.steps.nowStep)
              payload.data[1].questions.forEach(function () {
                state.steps.stepsLengthSection.push(null)
              })
            } else {
              /** on a une section choisie */
              let arrayOfIds = []
              payload.data.forEach(section => {
                arrayOfIds.push(section.id)
              })
              state.steps.stepsLengthSection.splice(0, state.steps.stepsLengthSection.length - state.steps.nowStep)
              payload.data[state.radioAnswerConditonalSection].questions.forEach(function () {
                state.steps.stepsLengthSection.push(null)
              })
            }
          } else if (state.radioAnswerConditonalSection === null) {
            /** on passe à la section suivante */
            if (payload.data[state.indexConditionalSection + (state.steps.stepsLengthSection.length - state.radioAnswerConditonalSection)] === undefined) {
              payload.data[state.indexConditionalSection + 1].questions.forEach(function () {
                state.steps.stepsLengthSection.push(null)
              })
            } else {
              payload.data[state.radioAnswerConditonalSection + 1].questions.forEach(function () {
                state.steps.stepsLengthSection.push(null)
              })
            }
          }
        } else if (payload.params === 'initialisation') {
          /** on est à la première section => index 0 */
          payload.data[0].questions.forEach(function () {
            state.steps.stepsLengthSection.push(null)
          })
        } else if (payload.params === 'suivant') {
          /** on a une question */
        }
        break
    }
  },
  STEP_NEXT (state, payload) {
    switch (payload.type) {
      case 'simple':
        if (state.steps.nowStep + 1 < state.steps.stepsLength.length && state.steps.nowStep !== state.steps.stepsLength.length) {
          state.steps.nowStep += 1
          state.steps.authorizedSendForm = false
        } else if (state.steps.nowStep + 1 === state.steps.stepsLength.length && payload.localShowButton[payload.localShowButton.length - 1]) {
          state.steps.nowStep += 1
          state.steps.authorizedSendForm = true
        } else if (state.steps.nowStep + 1 === state.steps.stepsLength.length && !payload.localShowButton[payload.localShowButton.length - 1]) {
          state.steps.nowStep += 1
          state.steps.authorizedSendForm = false
        }

        break
      case 'sections':
        state.steps.nowStepSection += 1
        /** * section choisie (on calcule les steps en fonction de la section choisie) */
        if (payload.condtionalSection !== null && payload.condtionalSection !== 0) {
          let count = 0
          for (let i = 0; i < state.radioAnswerConditonalSection; i++) {
            count += payload.data[i].questions.length
          }
          state.steps.nowStep = count + 1
          if (state.steps.nowStep_temporary === null && (payload.condtionalSection === state.indexConditionalSection)) {
            state.steps.nowStep_temporary = state.steps.nowStep
          }
          if (payload.condtionalSection === state.indexConditionalSection) {
            state.steps.nowStep_temporary += 1
            state.steps.nowStep = state.steps.nowStep_temporary
          }
          // on vérifie si on est à la fin des questions de la section en cours
          if (state.indexConditionalSection === state.radioAnswerConditonalSection) {
            state.indexConditionalSection = state.radioAnswerConditonalSection + 1
          } else {
            state.indexConditionalSection = state.radioAnswerConditonalSection
            if (state.steps.nbQuestions === state.steps.nowStep && state.radioOptionalQuestion[state.steps.nowStep - 1] === 1) {
              state.steps.authorizedSendForm = true
            }
          }
        } /** on passe à la section ou à la question suivante */ else {
          if (payload.next === 'suivant' && state.steps.stepsLengthSection.length !== state.steps.nowStepSection) {
            // on vérifie si on est à la dernière question du formalulaire, si oui on passe le bouton 'valider' à true
            if (state.steps.nbQuestions === state.steps.nowStep + 1 && state.radioOptionalQuestion[state.steps.nowStep] === 1) {
              state.steps.authorizedSendForm = true
            }
            state.steps.nowStep += 1
          } else {
            // on vérifie si on est à la dernière question du formalulaire, si oui on passe le bouton 'valider' à true
            if (state.steps.nbQuestions === state.steps.nowStep + 1 && state.radioOptionalQuestion[state.steps.nowStep] === 1) {
              state.steps.authorizedSendForm = true
            }
            state.steps.nowStep += 1
            state.indexConditionalSection = state.indexConditionalSection + 1
          }
        }
        // on reinitialise le store "radioAnswerConditonalSection" à null
        state.radioAnswerConditonalSection = null
        break
    }
  },
  UPDATE_QUESTION_CURRENT_SECTION (state, payload) {
    state.steps.currentSection = payload
  },
  UPDATE_RELATION_SECTION (state, payload) {
    state.steps.relation_section = payload
  },
  UPDATE_SHOW_LOCAL_BUTTON (state, payload) {
    switch (payload.type) {
      case 'simple':
        if (payload.question_optional === 0 || payload.question_optional === undefined) {
          state.buttons.localShowButton.push(false)
        } else state.buttons.localShowButton.push(true)
        break
      case 'section':
        if (payload.question_relation_section !== undefined && !payload.question_optional !== undefined) {
          if (payload.question_relation_section || !payload.question_optional) {
            state.buttons.localShowButton.push(false)
          } else state.buttons.localShowButton.push(true)
        }
        break
    }
  },
  UDPATE_SHOW_NEXT (state, payload) {
    switch (payload.type) {
      case 'simple':
        state.buttons.localShowButton.splice([payload.index], 1, payload.response)
        break
      case 'section':
        state.buttons.localShowButton.splice([payload.index], 1, payload.response)
        break
    }
  },
  STEP_PREVIOUS (state, payload) {
    switch (payload.type) {
      case 'simple':
        state.steps.authorizedSendForm = false
        if (state.steps.nowStep > 0) state.steps.nowStep -= 1
        else state.steps.nowStep = 0
        break
      case 'section':
        break
    }
  },
  UPDATE_AUTHORIZED_VOTE (state, payload) {
    state.steps.authorizedVote = payload
  },
  UPDATE_AUTHORIZED_THANKS (state, payload) {
    state.steps.authorizedThanks = payload
  },
  UPDATE_RADIO_ANSWER_CONDTIONAL_SECTION (state, payload) {
    let arrayOfIds = []
    payload.data.forEach(section => {
      arrayOfIds.push(section.id)
    })
    if (payload.conditionalSection === null) state.radioAnswerConditonalSection = null
    else if (payload.conditionalSection === -1) state.radioAnswerConditonalSection = -1
    else state.radioAnswerConditonalSection = arrayOfIds.indexOf(payload.conditionalSection)
  },
  UPDATE_RADIO_ANSWERS_OPTIONAL (state, payload) {
    state.radioOptionalQuestion = []
    payload.forEach(section => {
      section.questions.forEach(question => {
        state.radioOptionalQuestion.push(question.optional)
      })
    })
  },
  UPDATE_AUTHORIZED_FORM (state, payload) {
    state.steps.authorizedSendForm = payload
  },
  RESET_NOWSTEP (state) {
    state.steps.nowStep = 1
  },
  RESET_STEPS_LENGHT (state, payload) {
    state.steps.resetStepsLength = payload
  },
  RESET_STORE_SECTION_FORM (state) {
    state.radioOptionalQuestion = []
    state.indexConditionalSection = 0
    state.radioAnswerConditonalSection = 0
    state.steps.stepsLengthSection = []
    state.buttons.localShowButton = []
    state.steps.nowStepSection = 0
    state.steps.nowStep = 1
    state.steps.nowStep_temporary = null
    state.steps.authorizedVote = true
    state.steps.authorizedThanks = false
    state.steps.authorizedSendForm = false
    state.steps.resetStepsLength = 1
    state.steps.steps_history = []
    state.steps.sections_history = []
    state.steps.currentSection = 0
    state.steps.relation_section = 0
  }
}

const actions = {}

const getters = {
  steps: state => state.steps,
  buttons: state => state.buttons,
  indexConditionalSection: state => state.indexConditionalSection,
  radioAnswerConditonalSection: state => state.radioAnswerConditonalSection,
  choosenLanguageClient: state => state.choosenLanguageClient,
  errorMaxCheckboxes: state => state.errorMaxCheckboxes,
  sondage: state => state.sondage
}

const clientModule = {
  state,
  mutations,
  actions,
  getters
}

export default clientModule



// WEBPACK FOOTER //
// ./src/store/modules/client/index.js